module.exports = __webpack_public_path__ + "img/red_068.447336c7.png";